import scraperImage from "../assets/scraperImage.webp";
import voiceTranscriptImage from "../assets/voiceTranscriptImage.webp";
import emailAgentImage from "../assets/emailAgentImage.webp";
import writeBetterImage from "../assets/writeBetterImage.webp";

export const acceleratorCardsMock = [
  {
    title: "Agentic Web Scraper",
    description:
      "It moves beyond simple scraping to deploy autonomous agents that can intelligently navigate, extract, and structure information from the most complex web environments. This engine transforms the unstructured web into a reliable, strategic asset, empowering you to build agents for live tracking, competitive analysis, or powering proprietary language models.",
    image: scraperImage,
  },
  {
    title: "Real-Time Voice Transcript & Translation (On-Prem)",
    description:
      "It provides real-time voice transcription and translation, feeding into a secure, agentic RAG workflow built on platforms like n8n. It can summarize meetings, create tasks, update CRMs, and query past conversations—all within a private, auditable environment that you control.",
    image: voiceTranscriptImage,
  },
  {
    title: "Email Agent (On-Prem)",
    description:
      "It operates entirely within your network, bringing intelligent automation to your email without ever sending data to an external server. It can prioritize critical messages, summarize long threads, and draft context-aware replies, reclaiming hundreds of hours of productivity while upholding the strictest data security standards.",
    image: emailAgentImage,
  },
  {
    title: "Write Better: Frictionless Communication Enhancement",
    description:
      "Write Better is a lightweight, on-device utility for instant text improvement. By using a simple keyboard shortcut (e.g., Cmd+E), any selected text is immediately rewritten for clarity, grammar, and professionalism. Because it processes text locally and is built on an open-source core, it offers a transparent and secure way to elevate communication quality across your entire company without privacy concerns.",
    image: writeBetterImage,
  },
];
